import CustomTable from "../../../../../../common/customTable/CustomTable";
import { EuMrvPortStaysColumnsOld } from "../../../../../../constants/CustomTableHeaders";

const EUMRVPortStaysOld = ({ data, loading }) => {
	return (
		<CustomTable
			columnsData={EuMrvPortStaysColumnsOld}
			renderTableData={data || []}
			customProps={{
				isLoading: loading,
				enableSort: false,
				enableToptoolbar: false,
			}}
		/>
	);
};
export default EUMRVPortStaysOld;
